// Current StableCoin List.
// Should check whether to decide using of assetid or asset name
export const StableAssets = [
  51435943, // USDC,
  37074699 // USDC
]
